import Vue from 'vue'
import VueRouter from 'vue-router'
import NProgress from '../assets/nprogress/nprogress'
import MSLogin from '../views/ms-login.vue'
import MSManageLogin from '../views/manageLogin.vue'
// import MSLogin from '../views/ms-login2.vue'
import MSHomePage from '../views/ms-homePage.vue'
import Routes from './projectRouter/index'
import { Loading, Message } from 'element-ui'

/**这里下面的测试组件-项目中可删除 */
import testRoutes from './testRouter'
import testHomePage from '../views/test/ms-testHome'
/** 
 * 如果使用模块化机制编程,导入 Vue 和 VueRouter，要调用Vue.use(VueRouter);
 * 通过 this.$router 访问路由器
 * 通过 this.$route 访问当前路由
 */
Vue.use(VueRouter)


const routes = [{
    path: '/',
    redirect: '/login'
},
{
    path: '/login',
    name: 'login',
    component: MSLogin,
},
{
    path: '/manageLogin',
    name: 'manageLogin',
    component: MSManageLogin
},
{
    path: '/',
    name: 'home',
    redirect: '/home',
    // component: testHomePage,
    component: MSHomePage,
    children: Routes
},

...testRoutes,
{
    /**
     * 使用通配符捕捉404页面
     */
    path: '*',
    redirect: '/notFound'
},
];

let router = new VueRouter({ // 可通过 addRoutes 动态添加路由，可以把路由分为两部分一部分的 普通用户 一部分为 admin
    mode: 'history'
})

/** 
 * import xxx form xxx 这里可以把其他模块化的路由引进来然后合并
 * 通过 rest 运算符结构数组
 */

router.addRoutes([
    ...routes
    // ...xxx
])


router.beforeEach((to, from, next) => {

    const user = localStorage.getItem('user');
    NProgress.start();
    if (user || to.path === "/login" || to.path === '/manageLogin') {
        next()
    } else {
        Message.warning('登录过期，请重新登录')
        next('/')
    }


})


router.afterEach((to, from) => {

    NProgress.done();
    // console.log('this is to###afterEach####', to)
    // console.log('this is from###afterEach####', from)
})



export default router


// WEBPACK FOOTER //
// ./src/router/index.js